// extracted by mini-css-extract-plugin
module.exports = {"body":"layout_body__Hu25b"};